import { ILanguage } from '@models/languages/language';

export class ForgotPasswordTranslation {
    subject: { [key: string]: string };
    header_text: { [key: string]: string };
    footer_text: { [key: string]: string };
    email_has_been_sent_phrase: { [key: string]: string };
    reset_your_password_phrase: { [key: string]: string };

    constructor(languages: ILanguage[]) {
        languages.forEach(language => {
            this.subject = {
                ...this.subject,
                [language.code]: ''
            };
            this.header_text = {
                ...this.header_text,
                [language.code]: ''
            };

            this.email_has_been_sent_phrase = {
                ...this.email_has_been_sent_phrase,
                [language.code]: ''
            };
            this.footer_text = {
                ...this.footer_text,
                [language.code]: ''
            };
            this.reset_your_password_phrase = {
                ...this.reset_your_password_phrase,
                [language.code]: ''
            };
        });
    }
}
